// ABOUTME: Flags de funcionalidad leídos de variables de entorno VITE_*. Apagados por defecto:
// ABOUTME: solo encienden con un valor afirmativo explícito, para que un typo nunca active nada.

const ON_VALUES = new Set(["on", "1", "true", "yes", "si"]);

/** `true` solo si el valor es afirmativo (on/1/true/yes/si); vacío, ausente o cualquier otra cosa = apagado. */
export function isFeatureOn(value: string | undefined): boolean {
  return ON_VALUES.has((value ?? "").trim().toLowerCase());
}
